(() => {
  if (window.__reviewsCarouselsScriptLoaded) return;
  window.__reviewsCarouselsScriptLoaded = true;

  function getNumberAttr(el, name, fallback = 0) {
    const v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  const px = (v) => `${v}px`;

  function initReviewsCarousels() {
    document
      .querySelectorAll('.js-reviews-carousel')
      .forEach((carousel) => {
        if (carousel.__splide) return;

        const largeDesktop = getNumberAttr(carousel, 'data-large-desktop-items-per-row', 1);
        const desktop      = getNumberAttr(carousel, 'data-desktop-items-per-row', 1);
        const laptop       = getNumberAttr(carousel, 'data-laptop-items-per-row', 1);
        const tablet       = getNumberAttr(carousel, 'data-tablet-items-per-row', 1);
        const mobile       = getNumberAttr(carousel, 'data-mobile-items-per-row', 1);

        const spaceLgHalf  = getNumberAttr(carousel, 'data-large-desktop-items-space', 0);
        const spaceDHalf   = getNumberAttr(carousel, 'data-desktop-items-space', 0);
        const spaceLapHalf = getNumberAttr(carousel, 'data-laptop-items-space', 0);
        const spaceTabHalf = getNumberAttr(carousel, 'data-tablet-items-space', 0);
        const spaceMobHalf = getNumberAttr(carousel, 'data-mobile-items-space', 0);

        const gapLg   = spaceLgHalf  * 2;
        const gapD    = spaceDHalf   * 2;
        const gapLap  = spaceLapHalf * 2;
        const gapTab  = spaceTabHalf * 2;
        const gapMob  = spaceMobHalf * 2;

        const splide = new Splide(carousel, {
          type: 'slide',
          perPage: largeDesktop,
          perMove: 1,
          arrows: true,
          pagination: true,
          rewind: true,
          gap: px(gapLg),
          breakpoints: {
            1798: { perPage: desktop, gap: px(gapD) },
            1298: { perPage: laptop,  gap: px(gapLap) },
            991:  { perPage: tablet,  gap: px(gapTab) },
            767:  { perPage: mobile,  gap: px(gapMob) },
          },
          arrowPath:
            "M12.744 18.9481C12.5878 19.1044 12.5 19.3163 12.5 19.5373C12.5 19.7582 12.5878 19.9702 12.744 20.1264L17.4582 24.8406C17.6153 24.9924 17.8258 25.0764 18.0443 25.0745C18.2628 25.0726 18.4718 24.9849 18.6263 24.8304C18.7808 24.6759 18.8685 24.4669 18.8704 24.2484C18.8723 24.0299 18.7883 23.8194 18.6365 23.6623L15.3448 20.3706H26.3807C26.6017 20.3706 26.8136 20.2828 26.9699 20.1265C27.1262 19.9702 27.214 19.7583 27.214 19.5373C27.214 19.3162 27.1262 19.1043 26.9699 18.948C26.8136 18.7917 26.6017 18.7039 26.3807 18.7039H15.3448L18.6365 15.4123C18.7883 15.2551 18.8723 15.0446 18.8704 14.8261C18.8685 14.6076 18.7808 14.3986 18.6263 14.2441C18.4718 14.0896 18.2628 14.0019 18.0443 14.0001C17.8258 13.9981 17.6153 14.0821 17.4582 14.2339L12.744 18.9481Z"
        });

        carousel.__splide = splide;
        carousel.classList.add('active');

        splide.on('mounted move updated', () => {
          const Slides = splide.Components.Slides.getLength();
          const perPage = splide.options.perPage;

          const arrows = splide.root.querySelector('.splide__arrows');

          if (Slides <= perPage) {
            arrows.style.display = 'none';
          } else {
            arrows.style.display = '';
          }
        });
        
        splide.mount();
      });
  }

  document.addEventListener('DOMContentLoaded', initReviewsCarousels);
  document.addEventListener('shopify:section:load', initReviewsCarousels);
  document.addEventListener('shopify:section:reorder', initReviewsCarousels);
  document.addEventListener('shopify:section:select', initReviewsCarousels);
  document.addEventListener('shopify:block:select', initReviewsCarousels);
  document.addEventListener('shopify:block:deselect', initReviewsCarousels);
})();